import { AmortizationOperation } from '../types/CapitalAmortization';

export const fmtDate = (d?: string) =>
  d ? new Date(d).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '-';

/** Mensaje de error devuelto por el backend (400/409) o uno genérico. */
export const apiErrorMessage = (err: unknown, fallback: string): string => {
  const message = (err as { response?: { data?: { message?: string } } })?.response?.data?.message;
  return message || fallback;
};

const csvCell = (v: unknown) => {
  const s = v === undefined || v === null ? '' : String(v);
  return /[";\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const csvNum = (n?: number) => (n === undefined || n === null ? '' : n.toFixed(2).replace('.', ','));

/** Exporta la negociación de una operación a CSV (separador ;, decimales con coma, para Excel). */
export const exportOperacionCsv = (op: AmortizationOperation) => {
  const header = ['Inversor', 'Estado', 'Destino', 'Producto reinversión', 'Fase', 'Ficha', 'Capital vivo',
    'Capital amortizado', 'Capital restante', 'Intereses tramo', 'A cuenta imputados', 'Fidelización tramo',
    'Fidelización imputada', 'Bruto', 'IRPF', 'Neto', 'IBAN', 'Resumen'];
  const rows = op.amortizaciones.flatMap(a => a.lines.map(l => [
    a.investorName, a.estado, a.destino === 'REINVERSION' ? 'Reinversión' : 'Devolución', a.destinoDetalle ?? '',
    l.phaseName, l.investmentSheetId, csvNum(l.capitalPrevio), csvNum(l.capitalAmortizado), csvNum(l.capitalRestante),
    csvNum(l.interesTramo), csvNum(l.interesesCuentaImputados), csvNum(l.fidelizacionTramo), csvNum(l.fidelizacionImputada),
    csvNum(l.pendienteBruto), csvNum(l.retencionIrpf), csvNum(l.neto), l.ibanDevolucion ?? '', a.resumen,
  ]));
  const csv = [header, ...rows].map(r => r.map(csvCell).join(';')).join('\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `amortizacion_${op.productId}_${op.fechaCorte}.csv`;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
};
